<!--cart  -->
<div class="show-cart color2-bg"><i class="far fa-shopping-cart"></i><span>3</span></div>
<div class="cart-overlay"></div>
<div class="cart-modal">
    <div class="cart-modal-wrap fl-wrap">
        <span class="close-cart color2-bg">Close <i class="fal fa-times"></i> </span>
        <h3>Your cart</h3>
        <div class="clear-cart"> <span class="tolt" data-microtip-position="left" data-tooltip="Remove All"><i class="fal fa-trash-alt"></i></span></div>
        <ul class="cart-modal-list no-list-style fl-wrap">
            <li>
                <a class="cart-modal-image" href="product-single.html">
                    <img src="../../assets/images/shop/1.jpg" alt="Product image unavailable" loading="lazy" decoding="async">
                </a>
                <div class="cart-modal-det">
                    <a href="product-single.html">Grilled Filet of Cod</a>
                    <div class="quantity"><span>1</span> x <span class="woocommerce-Price-amount">₹56.15</span></div>
                </div>
                <a href="#" class="remove"><i class="fal fa-times-circle"></i></a>
            </li>
            <li>
                <a class="cart-modal-image" href="product-single.html">
                    <img src="../../assets/images/shop/1.jpg" alt="Product image unavailable" loading="lazy" decoding="async">
                </a>
                <div class="cart-modal-det">
                    <a href="product-single.html">Saute Crispy Goats</a>
                    <div class="quantity"><span>1</span> x <span class="woocommerce-Price-amount">₹17.00</span></div>
                </div>
                <a href="#" class="remove"><i class="fal fa-times-circle"></i></a>
            </li>
            <li>
                <a class="cart-modal-image" href="product-single.html">
                    <img src="../../assets/images/shop/1.jpg" alt="Product image unavailable" loading="lazy" decoding="async">
                </a>
                <div class="cart-modal-det">
                    <a href="product-single.html">Warm Chocolate Pudding</a>
                    <div class="quantity"><span>2</span> x <span class="woocommerce-Price-amount">₹90.20</span></div>
                </div>
                <a href="#" class="remove"><i class="fal fa-times-circle"></i></a>
            </li>
        </ul>
        <div class="cart-modal-total fl-wrap">
            <span class="cart-modal-total-title">SUBTOTAL:</span> <span class="woocommerce-Price-amount"> ₹253.55</span>
        </div>
        <div class="cart-sb_footer fl-wrap">
            <a href="cart.html" class="cart_btn color2-bg" title="View Cart">View Cart</a>
            <a href="booking.html" class="cart_btn color-bg" title="Checkout">Checkout</a>
        </div>
    </div>
</div>
<!--cart end-->